import React from 'react';
import './SiteFilterPills.css';

/**
 * SiteFilterPills — pills toggleables para filtrar por sitio.
 *
 * Props:
 *  - sites: string[] — ej ['Frecuento', 'Tipti Ecuador', 'Tuti']
 *  - active: Set<string> — sitios actualmente activos
 *  - onToggle: (site: string) => void
 */
function SiteFilterPills({ sites = [], active, onToggle }) {
  if (!sites || sites.length === 0) return null;
  const activeSet = active instanceof Set ? active : new Set(active || []);

  return (
    <div className="site-filter-pills" role="group" aria-label="Filtrar por sitio">
      {sites.map(site => {
        const isActive = activeSet.has(site);
        return (
          <button
            key={site}
            type="button"
            className={`site-pill ${isActive ? 'active' : ''}`}
            onClick={() => onToggle(site)}
            title={isActive ? `Ocultar ${site}` : `Mostrar ${site}`}
          >
            {site}
          </button>
        );
      })}
    </div>
  );
}

export default SiteFilterPills;
